import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { themeGet } from '@styled-system/theme-get';

export const PlayBtn = styled.button`
  position: relative;

  color: ${themeGet('colors.white')};
  background-color: ${themeGet('colors.orange')};
  border-radius: 50%;
  height: 46px;
  width: 46px;

  margin: auto 0;
  top: 8%;

  &:focus,
  &:hover {
    &::after {
      transform: translate(-50%, -50%) scale(0);
    }
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    background-color: ${themeGet('colors.white')};
    border-radius: 50%;
    opacity: 0.2;
    transition: all 500ms ease-in-out;

    height: 72px;
    width: 72px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 72px;
    width: 72px;

    &::after {
      content: '';
      height: 100px;
      width: 100px;
    }
  }
`;

export const PlayIcon = styled(FontAwesomeIcon)``;
